/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ComplianceReturnRequest = {
  properties: {
    userId: {
      type: 'string',
      isRequired: true,
    },
    professionalId: {
      type: 'string',
      isRequired: true,
    },
    reason: {
      type: 'string',
      isRequired: true,
    },
  },
} as const;
